/**
 * Scrolls smoothly to a section on the page
 * @param href - The href string (e.g., '#start', '#new-drones', '#')
 * @param options - Optional configuration
 * @param options.onComplete - Callback function to execute after scrolling
 */
export function scrollToSection(href: string, options?: { onComplete?: () => void }): void {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const behavior: ScrollBehavior = prefersReducedMotion ? 'auto' : 'smooth';

  const header = document.querySelector('header');
  const headerHeight = header?.getBoundingClientRect().height ?? 0;
  const offset = Math.round(headerHeight + 16);

  const targetId = href.substring(1);
  const element = targetId ? document.getElementById(targetId) : null;

  if (href === '#start' || href === '#') {
    window.scrollTo({ top: 0, behavior });
    options?.onComplete?.();
  } else if (element) {
    const targetTop = element.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, targetTop), behavior });
    options?.onComplete?.();
  }
}
